import { get } from 'common';

const COURSES_ROUTE = `${process.env.REACT_APP_API_CONFIG}courses`;

export class CoursesService {
    private static instance: CoursesService;

    static getInstance(): CoursesService {
        if (!this.instance) {
            this.instance = new CoursesService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${COURSES_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${COURSES_ROUTE}/${id}`);
    }
}
